"use client"

import * as TabsPrimitive from "@radix-ui/react-tabs"
import { TabsList } from "./TabsList"
import { TabsTrigger } from "./TabsTrigger"
import { TabsContent } from "./TabsContent"

/**
 * @group Components
 * @summary <blockquote>Root Tabs component that manages tab state.</blockquote>
 * @example
 * ```tsx
 * <Tabs defaultValue="tab1">
 *   <TabsList>
 *     <TabsTrigger value="tab1">Tab 1</TabsTrigger>
 *     <TabsTrigger value="tab2">Tab 2</TabsTrigger>
 *   </TabsList>
 *   <TabsContent value="tab1">Content 1</TabsContent>
 *   <TabsContent value="tab2">Content 2</TabsContent>
 * </Tabs>
 * ```
 */
const Tabs = TabsPrimitive.Root

export { Tabs, TabsList, TabsTrigger, TabsContent }
